<div class="size-full flex flex-col bg-white dark:bg-neutral-800">
  <!-- 顶部栏全宽：返回 + 当前学生信息 -->
  <div class="w-full flex border-b border-gray dark:border-gray-40 dark:bg-black">
    <button
      nz-button
      nzType="text"
      (click)="close()"
      class="w-12 h-full max-h-12 min-h-10 flex items-center justify-center"
    >
      <nz-icon nzType="arrow-left" nzTheme="outline" class="text-xl" />
    </button>
    <div class="flex-1 h-12 flex items-center px-2 text-xl text-black dark:text-white">
      @if (current(); as student) {
        <span>
          {{ student.firstName }} 第{{ currentQuestionNo() }}题 得分: {{ student.score ?? '--' }}分
          @if (student.reason) {
            <span class="ml-2">分享原因: {{ student.reason }}</span>
          }
        </span>
      } @else {
        <span class="text-neutral-n3">暂无作答</span>
      }
    </div>
    <!-- 复核：带着当前学生进入该题的复核阅卷页，显示条件见 canReview -->
    @if (canReview()) {
      <button nz-button type="button" class="mr-2 self-center" (click)="review()">复核</button>
    }
  </div>
  <div class="flex-1 min-h-0 relative">
    <lib-picture-viewer
      class="block size-full"
      [images]="photos()"
      [defaultMarkData]="markData()"
      [collect]="collect()"
      [downloadFileName]="downloadFileName()"
      [headerHidden]="true"
      (onClose)="close()"
      (onCollect)="toggleCollect()"
    />
    @if (!photos().length) {
      <div class="absolute inset-0 flex items-center justify-center text-sm text-neutral-n3 pointer-events-none">
        暂无作答图片
      </div>
    }
    <!-- 左右切换箭头：置灰仍可点击，用于提示已到边界 -->
    <button
      type="button"
      class="viewer-nav-arrow left-4"
      [class.viewer-nav-arrow-disabled]="index() <= 0"
      aria-label="上一个"
      (click)="switchStudent(-1)"
    >
      <nz-icon nzType="left" nzTheme="outline" />
    </button>
    <button
      type="button"
      class="viewer-nav-arrow right-4"
      [class.viewer-nav-arrow-disabled]="index() < 0 || index() >= total() - 1"
      aria-label="下一个"
      (click)="switchStudent(1)"
    >
      <nz-icon nzType="right" nzTheme="outline" />
    </button>
  </div>
</div>
